export default {
  date: 'August 2, 2024',
  title: 'New update on the website —  "Personal Account"',
  description: 'This dashboard is designed to make tracking and storing floor plans more convenient and efficient.',
  id: 'personal-account',
  jsx: () => (
    <div class='novelty__text'>
      <p>We're updating to become even more convenient for you. We are pleased to introduce our new service on the website – the “Personal Account”.</p>
      <p>This user dashboard is designed specifically to make tracking and storing floor plans even more convenient and efficient.</p>
      <b>Why do you need a “Personal Account”?</b>
      <p>
        With the “Personal Account”, you get a unique opportunity to store all 3D visualizations of your projects in one place. If you need to make changes to a 3D floor plan, you can easily send a list of corrections through your personal account. This update is especially useful for managing large
        real estate projects that include 10 to 100 floor plans. Your projects will always be organized and accessible through a user-friendly interface.
      </p>
      <b>How to use the new user dashboard?</b>
      <p>To start using the “Personal Account”, follow these steps:</p>
      <p class='margin-none'>
        1. Go to our website:
        <a href='https://getfloorplan.com'> getfloorplan.com</a>
      </p>
      <p class='margin-none'>2. Click on the “Sign up” button: This will take you to the registration page.</p>
      <p>3. Fill in the registration fields: If you have previously placed orders, please use the same email address used for payment.</p>
      <p>
        We are confident that our “Personal Account” update will significantly simplify the management of your real estate projects and allow you to interact more efficiently with our system. All your content will be stored in one place, and you will be able to easily track and make necessary
        changes.
      </p>
      <p>Thank you for choosing Getfloorplan, and we hope that the new update will make your experience even more positive.</p>
    </div>
  ),
  thumb: 'news/26.webp',
};
